package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_task_data_di_TaskModule : Module get() = module {
	single() { _ -> com.essntl.features.task.data.repository.TaskRepositoryImpl(supabase=get()) } bind(com.essntl.features.task.domain.repository.TaskRepository::class)
	single() { _ -> com.essntl.features.task.data.supabase.TaskSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.task.data.supabase.TaskSupabaseDataSource::class)
}
public val com.essntl.features.task.data.di.TaskModule.module : org.koin.core.module.Module get() = com_essntl_features_task_data_di_TaskModule
